import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getZendeskAuthenticationSetting, getUserInfoFromToken } from 'actions'

import Authentication from 'components/Admin/Integrations/ZendeskSatisfaction/Authentication'
import SyncManagement from 'components/Admin/Integrations/ZendeskSatisfaction/SyncManagement'
import ZendeskHeader from './Headers'
import Title from 'shared/components/Title'
import { IntegrationContainer } from 'components/IntegrationContainer'

class IntegrationZendeskFeedbackImport extends React.Component {
  static propTypes = {
    authenticationSettings: PropTypes.object,
    getZendeskAuthenticationSetting: PropTypes.func,
    getUserInfoFromToken: PropTypes.func,
    companyInfo: PropTypes.object,
  }

  componentDidMount() {
    this.props.getUserInfoFromToken()
    this.props.getZendeskAuthenticationSetting()
  }

  getCompanyId = () => {
    if (this.props.companyInfo) {
      const companyId = this.props.companyInfo.id
      return companyId
    }
  }

  render() {
    const companyId = this.getCompanyId()

    return (
      <React.Fragment>
        <IntegrationContainer>
          <Title title="Zendesk" />
          <div>
            <ZendeskHeader />
            {this.props.authenticationSettings.isActive ? (
              <SyncManagement
                authenticationSettings={this.props.authenticationSettings}
                companyId={companyId}
              />
            ) : (
              <InactivatedZendeskFeedbackImport
                zendeskAuthenticationSettings={this.props.authenticationSettings}
              />
            )}
          </div>
        </IntegrationContainer>
      </React.Fragment>
    )
  }
}

const mapState = ({ data }) => ({
  authenticationSettings: data.integrations.zendesk.authentication,
  companyInfo: data.userInfo.company,
})

const mapDispatch = (dispatch) => ({
  getZendeskAuthenticationSetting: () => dispatch(getZendeskAuthenticationSetting()),
  getUserInfoFromToken: () => dispatch(getUserInfoFromToken()),
})

export default connect(mapState, mapDispatch)(IntegrationZendeskFeedbackImport)

function InactivatedZendeskFeedbackImport({ zendeskAuthenticationSettings }) {
  return <Authentication zendeskAuthenticationSettings={zendeskAuthenticationSettings} />
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Integrations/ZendeskFeedbackImport/index.js